// class SidebarDrawer extends HTMLElement {
//     open() {
//         this.setAttribute("open", ""), initCustomSlickSlider(this.querySelector("#recently-viewed"));
//     }
//     close() {
//         this.removeAttribute("open");
//     }
//     connectedCallback() {
//         this.querySelector(".close-btn").addEventListener("click", () => this.close());
//     }
// }
function initCustomSlickSlider(e) {
    $(e)
        .find(".custom-slick-slider")
        .each(function () {
            var e = $(this);
            e.hasClass("slick-initialized") && e.slick("unslick");
            var t = parseInt(e.data("slides-mobile-small")) || 1,
                s = parseInt(e.data("slides-mobile")) || 2,
                i = parseInt(e.data("slides-tablet")) || 3,
                n = parseInt(e.data("slides-laptop")) || 4,
                o = parseInt(e.data("slides-desktop")) || 5,
                r = !0 === e.data("autoplay") || "true" === e.data("autoplay"),
                a = parseInt(e.data("speed")) || 3e3,
                l = !0 === e.data("arrows") || "true" === e.data("arrows"),
                d = !0 === e.data("dots") || "true" === e.data("dots");
            e.on("init", function () {
                e.addClass("slider-loaded");
            }),
                e.slick({
                    slidesToShow: o,
                    slidesToScroll: 1,
                    dots: d,
                    arrows: l,
                    autoplay: r,
                    autoplaySpeed: a,
                    prevArrow:
                        '<button type="button" class="slick-prev slick-arrow" aria-label="Previous">\n                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n                    </svg>\n                  </button>',
                    nextArrow:
                        '<button type="button" class="slick-next slick-arrow" aria-label="Next">\n                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                      <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n                    </svg>\n                  </button>',
                    responsive: [
                        { breakpoint: 1400, settings: { slidesToShow: n } },
                        { breakpoint: 990, settings: { slidesToShow: i } },
                        { breakpoint: 768, settings: { slidesToShow: s } },
                        { breakpoint: 425, settings: { slidesToShow: t } },
                    ],
                });
        });
}
customElements.define("sidebar-drawer", SidebarDrawer),
    document.addEventListener("DOMContentLoaded", function () {
        var e = document.querySelector("sidebar-drawer"),
            t = document.getElementById("headerCartIcon");
        t &&
            e &&
            t.addEventListener("click", function (t) {
                t.preventDefault(), e.open();
            });
    }),
    $(document).ready(function () {
        initCustomSlickSlider(document);
    }),
    document.addEventListener("shopify:section:load", function (e) {
        initCustomSlickSlider(e.target);
    }),
    document.addEventListener("shopify:section:select", function (e) {
        initCustomSlickSlider(e.target);
    }),
    document.addEventListener("shopify:block:select", function (e) {
        initCustomSlickSlider(e.target);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
        initCustomSlickSlider(e.target);
    }),
    document.addEventListener("shopify:section:deselect", function () {
        initCustomSlickSlider(document);
    }),
    $(document).on("click", ".tab-link", function () {
        const e = $(this).data("tab");
        $(this).addClass("active").siblings().removeClass("active"),
            $("#" + e)
                .addClass("active")
                .siblings(".tab-content")
                .removeClass("active"),
            initCustomSlickSlider("#" + e);
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelectorAll(".reveal-on-scroll");
        if ((e.forEach((e) => e.classList.remove("is-visible")), !("IntersectionObserver" in window)))
            return void e.forEach((e) => e.classList.add("is-visible"));
        const t = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    if (!e.isIntersecting) return;
                    const s = e.target,
                        i = s.parentElement.querySelectorAll(".reveal-on-scroll");
                    i.length > 1
                        ? (i.forEach((e, t) => {
                              setTimeout(() => {
                                  e.classList.add("is-visible"),
                                      setTimeout(() => {
                                          e.classList.remove("reveal-on-scroll");
                                      }, 600);
                              }, 80 * t);
                          }),
                          i.forEach((e) => t.unobserve(e)))
                        : (s.classList.add("is-visible"),
                          setTimeout(() => {
                              s.classList.remove("reveal-on-scroll");
                          }, 600),
                          t.unobserve(s));
                });
            },
            { threshold: 0.2 }
        );
        e.forEach((e) => t.observe(e));
    });
